<template>
  <div class="clueListBox">
      <div style="display: flex">
          <el-form ref="listArgument" :model="listArgument">
              <el-form-item prop="name">
                  <el-input v-model="listArgument.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item prop="com_name">
                  <el-input v-model="listArgument.com_name" placeholder="请输入公司名称"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                  <el-input v-model="listArgument.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="status">
                  <el-select
                      v-model="listArgument.status"
                      class="filter-item common-r"
                      placeholder="请选择跟进状态"
                  >
                      <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item v-if="user_type==2" prop="zuoxi_mobile">
                  <el-select
                      v-model="listArgument.zuoxi_mobile"
                      class="filter-item common-r"
                      placeholder="请选择坐席"
                  >
                      <el-option
                          v-for="item in seatsList"
                          :key="item.mobile"
                          :label="item.name"
                          :value="item.mobile">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <div class="searchBox">
              <el-button type="primary" @click="searchBtn">搜索</el-button>
              <el-button @click="clearBtn">清空</el-button>
          </div>
      </div>
      <avue-crud :data="data"  ref="crud" :option="option"
                 @size-change="sizeChange" :page.sync="page" @current-change="currentChange">
          <template slot-scope="scope" slot="tel">
              <div style="display: flex;justify-content: center;align-items: center">
                  <p style="width: 75px">{{scope.row.tel}}</p>
                  <img src="../../assets/img/phone.png" alt=""
                       style="width: 16px;height: 16px;cursor: pointer;margin-left: 10px"
                       @click="telephoneBtn(scope.row)">
              </div>
          </template>
          <template slot-scope="scope" slot="phone">
              <div style="display: flex;justify-content: center;align-items: center">
                  <p style="width: 75px">{{scope.row.phone}}</p>
                  <img src="../../assets/img/phone.png" alt=""
                       style="width: 16px;height: 16px;cursor: pointer;margin-left: 10px"
                       @click="dialingBtn(scope.row)">
              </div>
          </template>
          <template slot-scope="scope" slot="status_txt">
              <div style="display: flex;justify-content: center;align-items: center">
                  <p style="width: 50px">{{scope.row.status_txt}}</p>
                  <img src="../../assets/img/edit.png" alt=""
                       style="width: 16px;height: 16px;cursor: pointer;margin-left: 10px"
                        @click="editBtn(scope.row)">
              </div>
          </template>
          <template slot-scope="scope" slot="menuLeft">
              <el-button class="custom" type="primary" @click="importBtn">批量导入线索</el-button>
          </template>
          <template slot="menuBtn" slot-scope="scope">
              <el-dropdown-item class="pull-down" @click.native="detailsBtn(scope.row)">线索详情</el-dropdown-item>
              <el-dropdown-item class="pull-down" @click.native="deleteBtn(scope.row)">线索删除</el-dropdown-item>
<!--              <el-dropdown-item class="pull-down" @click.native="addFollowUpBtn(scope.row)">添加跟进记录</el-dropdown-item>-->
          </template>
          <template slot="tag" slot-scope="scope">
              <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="scope.row.all_tag">
                  <span slot="reference" style="cursor:pointer;">{{scope.row.tag}}</span>
              </el-popover>
          </template>
      </avue-crud>
      <!--          编辑跟进状态-->
      <el-dialog
          title="提交标签、跟进状态、跟进记录"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="80%">
          <h4>一.标签</h4>
          <div class="tagBox">
              <p>联系方式反馈</p>
              <el-checkbox-group v-model="cluesLabel.selected_tagids">
                  <el-checkbox
                      v-for="item in cluesLabel.lxfsfk_list"
                      :key="item.tag_id"
                      :label="item.tag_id" border>
                      {{item.name}}
                  </el-checkbox>
              </el-checkbox-group>
              <p>意向类别反馈</p>
              <el-checkbox-group v-model="cluesLabel.selected_tagids">
                  <el-checkbox
                      v-for="item in cluesLabel.yxlbfk_list"
                      :key="item.tag_id"
                      :label="item.tag_id" border>
                      {{item.name}}
                  </el-checkbox>
              </el-checkbox-group>
              <p>线索质量反馈</p>
              <el-checkbox-group v-model="cluesLabel.selected_tagids">
                  <el-checkbox
                      v-for="item in cluesLabel.xszlfk_list"
                      :key="item.tag_id"
                      :label="item.tag_id" border>
                      {{item.name}}
                  </el-checkbox>
              </el-checkbox-group>
              <p>职位标签</p>
              <el-checkbox-group v-model="cluesLabel.selected_tagids">
                  <el-checkbox
                      v-for="item in cluesLabel.zwbq_list"
                      :key="item.tag_id"
                      :label="item.tag_id" border>
                      {{item.name}}
                  </el-checkbox>
              </el-checkbox-group>
              <p>意向等级分类</p>
              <el-checkbox-group v-model="cluesLabel.selected_tagids">
                  <el-checkbox
                      v-for="item in cluesLabel.yxdjfl_list"
                      :key="item.tag_id"
                      :label="item.tag_id" border>
                      {{item.name}}
                  </el-checkbox>
              </el-checkbox-group>
          </div>
          <h4>二、跟进状态</h4>
          <div class="status">
              <el-form ref="form" :model="form">
                  <el-form-item>
                      <el-radio-group
                          v-model="form.status"
                          class="filter-item common-r"
                          placeholder="请选择跟进状态"
                      >
                          <el-radio
                              v-for="item in statusList"
                              :key="item.value"
                              :label="item.value"
                              border>
                              {{item.label}}
                          </el-radio>
                      </el-radio-group>
                  </el-form-item>
              </el-form>
          </div>
          <h4>三、跟进记录</h4>
          <div class="record">
              <el-form ref="argument" :model="argument" style="flex-direction: column">
                  <el-form-item prop="genjin_type" label="跟进类型">
                      <el-radio-group
                          v-model="argument.genjin_type"
                          class="filter-item common-r"
                          placeholder="请选择跟进类型"
                      >
                          <el-radio
                              v-for="item in statusList2"
                              :key="item.value"
                              :label="item.value"
                              border>
                              {{item.label}}
                          </el-radio>
                      </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="remark" label="跟进记录">
                      <el-input v-model="argument.remark" placeholder="请输入跟进记录" type="textarea"></el-input>
                  </el-form-item>
                  <el-form-item prop="remark" label="跟进记录文件">
                      <el-upload
                          ref='upload'
                          class="inline"
                          :limit="1"
                          :on-preview="handlePreview"
                          :on-remove="(file, fileList) => {handleRemove(file, fileList, upload_data.doc_type)}"
                          :on-success="handleSuccess"
                          :on-exceed="handleExceed"
                          accept=".jpg,.jpeg,.png,.mp3,.wav"
                          :headers="headers"
                          :action="url"
                          name="file"
                          :data="upload_data"
                          :file-list="application"
                      >
                          <el-button class="custom" type="primary">
                              上传
                          </el-button>
                      </el-upload>
                  </el-form-item>
              </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelBtn">取 消</el-button>
                    <el-button type="primary" @click="confirmedBtn">确 定</el-button>
              </span>
      </el-dialog>
  </div>
</template>

<script>
import {
    callSeat,
    deleteClues,
    editFollowUpStatus,
    getCluesLabel,
    getCluesList,
    getSeatsList,
    submitCluesLabel
} from '@/api/callCenter';
import addFollowUp from '@/views/callCenter/components/addFollowUp.vue';

export default {
    name: 'clueList',

    data() {
        return {
            checked:true,
            cluesLabel:'',
            selected_tagids:[],
            dialogVisible:false,
            form:{
                id:'',
                status:''
            },
            url:process.env.VUE_APP_BASE_API+'/api/upload_zuoxi_genjin_file',
            headers:{
                "Authorization": sessionStorage.getItem("token"),
                "Comid": sessionStorage.getItem("shenfen"),
                "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
            },
            upload_data:{

            },
            application:[],
            argument:{
                genjin_type:'',
                remark:'',
                psd_code:''
            },
            statusList2:[
                {
                    value: '1',
                    label: '电话'
                },
                {
                    value: '2',
                    label: '微信'
                },
                {
                    value: '3',
                    label: 'QQ'
                },
                {
                    value: '4',
                    label: '短信'
                },
                {
                    value: '5',
                    label: '邮件'
                },
                {
                    value: '6',
                    label: '拜访'
                },
            ],
            listArgument:{
                name:'',
                com_name:'',
                phone:'',
                status:'',
                zuoxi_mobile:'',
                limit:10,
                page:1
            },
            page:{
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10
            },
            statusList:[
                {
                    value: '1',
                    label: '未处理'
                },
                {
                    value: '2',
                    label: '跟进中'
                },
                {
                    value: '3',
                    label: '无意向'
                },
                {
                    value: '4',
                    label: '有意向'
                },
                {
                    value: '5',
                    label: '初访'
                },
                {
                    value: '6',
                    label: '意向'
                },
                {
                    value: '7',
                    label: '报价'
                },
                {
                    value: '8',
                    label: '成交'
                },
                {
                    value: '9',
                    label: '暂时搁置'
                },
            ],
            seatsList:[],
            user_type:'',
            data: [],
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: false, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuWidth: 150,  //操作栏宽度设置
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '线索ID',
                        prop: 'id',
                        width: '60'
                    }, {
                        label: '姓名',
                        prop: 'name'
                    }, {
                        label: '公司名称',
                        prop: 'com_name'
                    },{
                        label: '负责人',
                        prop: 'mobile'
                    }, {
                        label: '创建时间',
                        prop: 'create_time'
                    }, {
                        label: '线索标签',
                        prop: 'tag'
                    }, {
                        label: '电话',
                        prop: 'tel'
                    }, {
                        label: '手机',
                        prop: 'phone'
                    }, {
                        label: '跟进状态',
                        prop: 'status_txt'
                    },
                ]
            }
        };
    },
    methods: {
        // 分页
        currentChange(num){
            this.listArgument.page = num;
            getCluesList(this.listArgument).then(res=>{
                this.data = res.data.list;
                this.page.total = res.data.count;
            })
            sessionStorage.setItem('clueList', num);

        },
        // 切换每一页条数
        sizeChange(val){
            this.listArgument.page = 1;
            this.listArgument.limit = val;
            sessionStorage.removeItem('clueList')
            this.getList()
        },
        // 搜索
        searchBtn(){
            this.listArgument.page = 1;
            this.getList();
        },
        // 清空
        clearBtn(){
            this.listArgument.page = 1;
            this.listArgument.limit = 10;
            sessionStorage.removeItem('clueList')
            this.getList()
            this.$refs.listArgument.resetFields();
        },
        getList(){
            let num = Number(sessionStorage.getItem('clueList'));

            getCluesList(this.listArgument).then(res=>{
                if (res.code==200){
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = (this.page.currentPage && num !== 0) ? num : 1;
                }else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 批量导入线索
        importBtn(){
            this.$router.push({
                path: '/importClues'
            });
        },
        // 线索详情
        detailsBtn(row){
            this.$router.push({
                path: '/clueDetails',
                query:{
                    id:row.id
                }
            })
        },
        // 线索删除
        deleteBtn(row){
            this.$confirm('请确认是否删除该线索 ', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteClues({id:row.id}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.getList()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {

            });
        },
        // 添加跟进记录
        addFollowUpBtn(row){
            this.$router.push({
                path: '/addFollowUp',
                query:{
                    id:row.id
                }
            })
        },
        // 电话拨号
        telephoneBtn(row){
            this.$confirm(`请确认是否要拨打${row.tel}号码 `, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                callSeat({id:row.id,tel_b:row.tel}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {

            });
        },
        // 手机拨号
        dialingBtn(row){
            this.$confirm(`请确认是否要拨打${row.phone}号码 `, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                callSeat({id:row.id,tel_b:row.phone}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {

            });
        },
        // 编辑
        editBtn(row){
            getCluesLabel({id:row.id}).then(res=>{
                if (res.code==200){
                    const selected = [
                        ...res.data.lxfsfk_list.filter(i => i.selected),
                        ...res.data.yxlbfk_list.filter(i => i.selected),
                        ...res.data.xszlfk_list.filter(i => i.selected),
                        ...res.data.zwbq_list.filter(i => i.selected),
                        ...res.data.yxdjfl_list.filter(i => i.selected)
                    ].map(i => i.tag_id)

                    this.cluesLabel = {
                        ...res.data,
                        selected_tagids: selected  // 统一存储所有选中标签ID
                    }
                    this.dialogVisible = true
                }
            })
            this.form.id = row.id
        },
        // 取消
        cancelBtn(){
            this.cluesLabel.selected_tagids=''
            this.form.status=''
            this.argument.genjin_type=''
            this.argument.remark=''
            this.argument.psd_code=''
            this.application=[]
            this.dialogVisible = false
        },
        // 确定
        confirmedBtn(){
            let data={
                id:this.form.id,
                selected_tagids:this.cluesLabel.selected_tagids,
                status:this.form.status,
                genjin_type:this.argument.genjin_type,
                remark:this.argument.remark,
                psd_code:this.argument.psd_code
            }
            submitCluesLabel(data).then(res=>{
                if (res.code==200){
                    this.$message.success(res.msg)
                    this.cancelBtn()
                    this.getList()
                }else{
                    this.$message.error(res.msg)
                }
            })
            // if (this.form.status===''){
            //     this.$message.error('请选择跟进状态')
            //     return
            // }else {
            //     editFollowUpStatus(this.form).then(res=>{
            //         if (res.code==200){
            //             this.$message.success(res.msg)
            //             this.dialogVisible = false
            //             this.form.status=''
            //             this.getList()
            //         }else {
            //             this.$message.error(res.msg)
            //         }
            //     })
            // }
        },
        //点击文件列表事件
        handlePreview(file){
            if (file.all_url){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.all_url);
            }else if (file.response){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.response.data.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.response.data.all_url);
            }
        },
        // 移除
        handleRemove(){

        },
        //上传成功
        handleSuccess(response, file, fileList){
            if (response.code == 200){
                this.argument.psd_code=response.data.psd_code
            }else {
                this.$message.error(response.msg);
            }
        },
        //限制条数
        handleExceed(files, fileList){
            if (fileList.length>=1){
                this.$message.error('只能上传1个文件');
            }
        },
    },
    created() {
        this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
        this.user_type=JSON.parse(sessionStorage.getItem('shenfen')).user_type;
        let num = Number(sessionStorage.getItem('clueList'));
        if (num==0){
            this.getList();
        }else{
            this.listArgument.page = num;
            getCluesList(this.listArgument).then(res=>{
                this.data = res.data.list;
                this.page.total = res.data.count;
                this.page.currentPage = num;
            })
        }
        getSeatsList().then(res=>{
            if (res.code==200){
                this.seatsList=res.data.list;
            }else{
                this.$message.error(res.msg);
            }
        })
    }
}
</script>

<style scoped lang="scss">
    .clueListBox{
        padding: 20px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .el-form{
        display: flex;
    }
    .el-form-item{
        display: flex;
        margin-right: 10px;
    }
    .pull-down{
        padding: 10px 30px;
    }
    .tagBox,.status, .record{
        margin:10px 20px;
        p{
            margin-bottom: 5px;
        }
    }
    ::v-deep .el-checkbox{
        width: 100px;
        margin:5px !important;
    }
    ::v-deep .el-dialog{
        margin-top: 5vh !important;
    }
    ::v-deep .el-dialog__body{
        padding:10px 20px;
        max-height: 700px;
        overflow-y: auto;
    }
    //.el-select{
    //    width: 30%;
    //}
    .el-textarea{
        width: 500px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        display: flex;
        align-items: center;
    }
    ::v-deep .el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .save{
        width: 120px;
        height: 40px;
        border-radius: 5px;
    }
    .fileContent>p{
        width: 150px;
        color: #666666;
        font-size: 14px;
    }
    ::v-deep .el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
    ::v-deep .el-radio{
        margin-right: 5px;
    }
    ::v-deep .el-radio__original {
        display: none !important;
    }
</style>